import { Box, Button, Chip, Paper, Typography } from '@mui/material';
import { keyframes } from '@mui/system';
import CheckIcon from '@mui/icons-material/Check';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import { SubmissionSendResult } from '../context/submission-send-reducer';

const popIn = keyframes`
  from { transform: scale(0.6); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`;

const fadeUp = keyframes`
  from { transform: translateY(8px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

interface SubmissionSuccessProps {
    result: SubmissionSendResult;
    onViewSubmission: (id: number) => void;
    onViewBatch: (batchId: number) => void;
    onNew: () => void;
}

export function SubmissionSuccess({ result, onViewSubmission, onViewBatch, onNew }: SubmissionSuccessProps) {
    const ids = result.submissionIds;
    const isBatch = !!result.batchId;
    const title = isBatch
        ? `Lote nº ${result.batchId} enviado com ${ids.length} remessas`
        : `Remessa nº ${ids[0] ?? ''} enviada`;

    return (
        <Paper sx={{ py: { xs: 5, md: 7 }, px: 3, textAlign: 'center', maxWidth: 720, mx: 'auto' }}>
            <Box
                sx={{
                    mx: 'auto', mb: 3, width: 88, height: 88, borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    bgcolor: 'success.main', color: 'success.contrastText',
                    boxShadow: (theme) => `0 0 0 12px ${theme.palette.success.main}1F`,
                    animation: `${popIn} 300ms cubic-bezier(0.34, 1.56, 0.64, 1) both`,
                    '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
                }}
            >
                <CheckIcon sx={{ fontSize: 48 }} />
            </Box>
            <Box sx={{ animation: `${fadeUp} 250ms ease-out 120ms both`, '@media (prefers-reduced-motion: reduce)': { animation: 'none' } }}>
                <Typography variant="h5" fontWeight={700}>{title}</Typography>
                <Typography color="text.secondary" sx={{ mt: 1, maxWidth: 480, mx: 'auto' }}>
                    {isBatch ? 'As remessas' : 'A remessa'} já {isBatch ? 'estão' : 'está'} na fila da diagramação. Acompanhe o andamento e o histórico na consulta de remessas.
                </Typography>
                {isBatch && (
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap', mt: 2 }}>
                        {ids.map((id) => <Chip key={id} label={`nº ${id}`} onClick={() => onViewSubmission(id)} variant="outlined" />)}
                    </Box>
                )}
                <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center', flexWrap: 'wrap', mt: 4 }}>
                    {isBatch
                        ? <Button variant="outlined" startIcon={<VisibilityIcon />} onClick={() => onViewBatch(result.batchId!)}>Ver lote</Button>
                        : ids[0] && <Button variant="outlined" startIcon={<VisibilityIcon />} onClick={() => onViewSubmission(ids[0])}>Ver remessa</Button>}
                    <Button variant="contained" startIcon={<AddIcon />} onClick={onNew}>Enviar nova remessa</Button>
                </Box>
            </Box>
        </Paper>
    );
}
